import { StrakitSelectComponent } from '@ngx-strakit/cdk/controls/select';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type NgSelectEvent = keyof Pick<StrakitSelectComponent, 'blurEvent' | 'focusEvent' | 'changeEvent' | 'openEvent' | 'closeEvent' | 'searchEvent' | 'clearEvent' | 'addEvent' | 'removeEvent' | 'scroll' | 'scrollToEnd'>;

export interface NgSelectEventHandler<TEventData = unknown> {
  readonly eventType: NgSelectEvent;
  handle(ngSelect: StrakitSelectComponent, event: TEventData): void | Observable<void>;
}

export const NG_SELECT_EVENT_HANDLER = new InjectionToken<NgSelectEventHandler>('Ng-select-field event handler');
